// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1G7Di","dragIcon":"Choice_dragIcon__ykp9d","left":"Choice_left__KwOti","input":"Choice_input__1ooeg"};